import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { GarantieDetail } from "../model/garanties/GarantieDetail";
import { GarantieMetadata } from "../model/garanties/GarantieMetadata";
import { GarantieDocument } from "../model/garanties/GarantieDocument";

@Injectable({
  providedIn: "root",
})
export class GarantieService {


  constructor(private _restClientService: RestClientService) {}

  getGarantiesByRequestId(requestId) {
    return this._restClientService.load<GarantieDetail[]>(
      "garanties-details/list/request/" + requestId
    );
  }

  addGarantieDetail(requestId, natureGarantieId, garantie) {
    return this._restClientService.save<GarantieDetail>(
      `garanties-details/add/dossier/${requestId}/nature/${natureGarantieId}`,
      garantie
    );
  }

  updateGarantieDetail(requestId, garantieId, garantie) {
    return this._restClientService.put<GarantieDetail>(
      `garanties-details/update/${requestId}/${garantieId}`,
      garantie
    );
  }

  deleteGarantieDetail(garantieId) {
    return this._restClientService.delete<GarantieDetail>(
      `garanties-details/delete/${garantieId}`
    );
  }

  getGarantieDetailInfos(garantieId) {
    return this._restClientService.load<GarantieMetadata[]>(
      "garanties-details/details/garantie-id/" + garantieId
    );
  }

  getGarantieMetadatas(garantieId) {
    return this._restClientService.load<GarantieMetadata[]>(
      "garanties-details/metadata/garantie-id/" + garantieId
    );
  }

  getEmptyDocumentsByRequest(requestId) {
    return this._restClientService.load<GarantieDocument[]>(
      "garanties-details/documents/request-id/" + requestId
    );
  }

  getEmptyDocumentsByRequestAndGarantie(requestId, garantieId) {
    return this._restClientService.load<GarantieDocument[]>(
      `garanties-details/documents/request-id/${requestId}/garantie-id/${garantieId}`
    );
  }

}
